module.exports = __webpack_public_path__ + "img/proof_of_initial_contribution.43302fd7.svg";